import ModalHeader from '@/components/modal/ModalHeader.tsx';
import React from 'react';
import Modal from '@/components/modal/Modal.tsx';
import ModalContent from '@/components/modal/ModalContent.tsx';
import { Card, CardContent } from '@/components/ui/Card.tsx';
import ModalFooter from '@/components/modal/ModalFooter.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { cn } from '@/lib/utils.ts';
import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';
import {
  CustomFieldTypeConfig,
  getFieldTypeConfig,
} from '@/features/dashboard/tourCustomFields/components/customFieldTypeConfig.tsx';

const AddCustomFieldModal = ({
  onClose,
  setActiveModal,
}: {
  onClose: () => void;
  setActiveModal: (a1: FieldType | null) => void;
}) => {
  const customFieldTypes = [
    {
      ...getFieldTypeConfig(FieldType.TEXT),
      onClick: () => setActiveModal(FieldType.TEXT),
    },
    {
      ...getFieldTypeConfig(FieldType.LONG_TEXT),
      onClick: () => setActiveModal(FieldType.LONG_TEXT),
    },
    {
      ...getFieldTypeConfig(FieldType.DROPDOWN),
      onClick: () => setActiveModal(FieldType.DROPDOWN),
    },
    {
      ...getFieldTypeConfig(FieldType.CHECKBOX),
      onClick: () => setActiveModal(FieldType.CHECKBOX),
    },
  ];

  return (
    <Modal onClose={onClose}>
      <ModalHeader title="Jakie pole chcesz dodać?" onClose={onClose} />
      <ModalContent>
        <div className="space-y-1">
          <h3 className="text-xl font-semibold leading-[120%]">
            Pola dodatkowe
          </h3>
          <div className="text-sm text-neutral-600">
            Tutaj możesz zebrać od uczestnika dowolne inne informacje.{' '}
            <b>Pola wymagają konfiguracji</b>.
          </div>
        </div>

        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
          {customFieldTypes.map((type) => (
            <CustomFieldTypeOption
              key={type.title}
              fieldTypeDef={{
                ...type,
                onClick: () => {
                  type.onClick();
                  onClose();
                },
              }}
            />
          ))}
        </div>
      </ModalContent>
      <ModalFooter>
        <ActionButton tone="outline" size="sm" onClick={onClose}>
          Zamknij
        </ActionButton>
      </ModalFooter>
    </Modal>
  );
};

interface CustomFieldTypeDefProps extends CustomFieldTypeConfig {
  onClick: () => void;
  disabled?: boolean;
}

const CustomFieldTypeOption = ({
  fieldTypeDef,
}: {
  fieldTypeDef: CustomFieldTypeDefProps;
}) => {
  return (
    <Card
      onClick={fieldTypeDef.disabled ? undefined : fieldTypeDef.onClick}
      className={cn('cursor-pointer transition hover:bg-neutral-50', {
        // Prefiksowy `!` to składnia Tailwinda 3 — w v4 klasa była martwa,
        // więc wyłączony kafel wyglądał i zachowywał się jak aktywny.
        'bg-basic-disabled-bg! pointer-events-none cursor-not-allowed shadow-none':
          fieldTypeDef.disabled,
      })}
    >
      <CardContent className="space-y-1 p-2">
        <div className="flex flex-row items-center gap-1.5">
          <div className="[&>svg]:size-4 [&>svg]:text-neutral-500">
            {fieldTypeDef.icon}
          </div>
          <span className="text-base font-medium leading-[100%] text-base-text">
            {fieldTypeDef.title}
          </span>
        </div>
        <span className="text-sm text-neutral-600">
          {fieldTypeDef.description}
        </span>
      </CardContent>
    </Card>
  );
};

export default AddCustomFieldModal;
